import { Form } from "react-bootstrap";
import type { Operand } from "./types";
import "./style.css";

export interface RefinementsEditorProps {
  subservices: { id: string; name: string }[];
  operands: Operand[];
  value: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
}

export const RefinementsEditor = ({
  subservices,
  operands,
  value,
  onChange,
}: RefinementsEditorProps): JSX.Element => {
  const set = (taskId: string, slug: string) =>
    onChange({ ...value, [taskId]: slug });

  return (
    <div>
      <h3 className="rec-section-title">Subservices</h3>
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Subservice</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {subservices.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>
                <Form.Control
                  as="select"
                  aria-label={`refinement ${s.id}`}
                  value={value[s.id] ?? ""}
                  onChange={(e) => set(s.id, e.target.value)}
                >
                  <option value="">Default</option>
                  {operands.map((o) => (
                    <option key={o.slug} value={o.slug}>
                      {o.name}
                    </option>
                  ))}
                </Form.Control>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RefinementsEditor;
